module.exports = __webpack_public_path__ + "AF.png?e369451b75b8e2aa1a551a21b47b0ac5";